import { render, staticRenderFns } from "./TrendingSpotlightModule.vue?vue&type=template&id=31702536"
import script from "./TrendingSpotlightModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendingSpotlightModule.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrendingSpotlightModule.vue?vue&type=style&index=0&id=31702536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports